import { toast } from 'react-toastify';

export const showAlert = ({ type = 'success', message, settings = {} }) => {
  toast(message, { type, ...settings });
  return { type: 'alert' };
};
